export default __webpack_public_path__ + "static/media/372e641d9f9d6997.a1cf3de0364bf5efcb4bbaad9cd7d702.svg";